import React, { useEffect, useState } from 'react';
import 'react-tooltip/dist/react-tooltip.css';
import MapChart from './analytics/MapChart';
import UserOverviewChart from './analytics/UserOverviewChart';
import MostVisitedPages from './analytics/MostVisitedPages';
import DevicesOverview from './analytics/DeviceOverview';
import api from '../services/Api';
import { countryNameToAbbreviation } from '../data/countries';

const DashboardCards = () => {
  const [data, setData] = useState([]);
  const [topCountries, setTopCountries] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

  const fetchData = async (month, year) => {
    try {
      const start = `${year}-${String(month).padStart(2, '0')}-01`;
      const end = `${year}-${String(month).padStart(2, '0')}-${new Date(year, month, 0).getDate()}`;

      const response = await api.get(`/analytics/daily`, {
        params: { start, end },
      });

      const formattedData = response.data.map(item => ({
        name: new Intl.DateTimeFormat('en-US', {
          day: '2-digit',
          month: 'long',
        }).format(new Date(item.date)),
        totalVisits: item.totalVisits,
        uniqueVisitors: item.uniqueVisitors,
      }));

      setData(formattedData);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const fetchTopCountries = async () => {
    try {
      const response = await api.get('/admin/user/users');

      if (Array.isArray(response.data.users)) {
        const countryCount = {};
        response.data.users.forEach(user => {
          if (user.country) {
            countryCount[user.country] = (countryCount[user.country] || 0) + 1;
          }
        });

        const countriesArray = Object.entries(countryCount).map(([name, users]) => ({
          name,
          users,
          percentage: ((users / response.data.total) * 100).toFixed(0),
        }));

        countriesArray.sort((a, b) => b.users - a.users);

        const topCountries = countriesArray.slice(0, 3);

        const topCountriesWithAbbrev = topCountries.map(country => {
          const nameWithUnderscores = country.name.replace(/\s+/g, '_');
          const abbr = countryNameToAbbreviation[nameWithUnderscores] || 'UN';
          return {
            ...country,
            id: abbr,
            photo: `https://flagsapi.com/${abbr}/flat/64.png`,
          };
        });

        setTopCountries(topCountriesWithAbbrev);
      }
    } catch (error) {
      console.error('Error fetching top countries:', error);
    }
  };
  useEffect(() => {
    fetchData(selectedMonth, selectedYear);
    fetchTopCountries();
  }, [selectedMonth, selectedYear]);

  const handleMonthChange = month => {
    setSelectedMonth(month);
  };

  const handleYearChange = year => {
    setSelectedYear(year);
  };

  return (
    <div className="p-4 sm:ml-64 w-[80%] bg-[#F4F5F6] font-nohemi">
      <div className="">
        <div className="flex flex-row justify-around gap-4 mb-4 h-[416px]">
          <div className="w-3/4 rounded bg-[#FFFFFF]">
            <UserOverviewChart
              data={data}
              selectedMonth={selectedMonth}
              selectedYear={selectedYear}
              onMonthChange={handleMonthChange}
              onYearChange={handleYearChange}
              Overview="User Overview"
            />
          </div>
          <div className="w-1/4 rounded bg-[#FFFFFF]">
            <MostVisitedPages />
          </div>
        </div>
        <div className="flex flex-row justify-between gap-4 my-4 h-[488px]">
          <div className="w-3/4 rounded bg-[#FFFFFF]">
            <div className="flex flex-row justify-between px-2 border-b-2 border-[#E5E7E8]">
              <div className="m-2">
                <p className="p-2 text-base font-medium">User Location</p>
              </div>
              <div className="m-2 bg-[#F5F6F7] rounded">
                <p className="font-medium text-sm text-[#4A5154] p-2">This month</p>
              </div>
            </div>
            <div className="relative w-[60%] h-[252px] mt-12 mx-auto overflow-hidden">
              <MapChart />
            </div>
            <div className="flex justify-around items-center mt-6 w-[85%] h-[132px] mx-auto">
              {topCountries.map(country => (
                <div className="flex items-center w-[154px] h-[64px] gap-2" key={country.id}>
                  <img src={country.photo} alt={country.name} className="object-cover w-8 h-6" />
                  <div className="flex flex-col">
                    <h1 className="text-sm font-light text-nowrap text-[#191B1C]">
                      {country.name}
                    </h1>
                    <p className="text-xs text-[#626C70]">
                      {country.percentage}% · +{country.users.toLocaleString()} Users
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="w-1/4 rounded bg-[#FFFFFF] mt-1 ml-1">
            <DevicesOverview />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardCards;
